/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useState } from 'react';
import { SyncOutlined } from '@ant-design/icons';
import { toastText } from 'utils/utils';
import { getPlanInfo } from '../planUtils';
import { useCompanyActions } from '../useCompanyActions';
// Two-plan (Basic/Plus) upgrade/downgrade is disabled — CAP ships a single plan.
// Kept commented for easy restore when the tiers are real again.
// import { usePlanChange } from '../usePlanChange';
// import PlanChangeModal from '../PlanChangeModal';
import styles from './index.module.scss';

/**
 * Per-company "Manage" page (opened from the subscriptions table's Manage link).
 * Shows the company's plan + connected integrations. QuickBooks Online is the
 * real integration (status/last-sync/disconnect wired to the live flow); the
 * others are example integrations per the product design.
 */
const ManageCompany = (props: any) => {
	const {
		data,
		onBack,
		setSelectedSidebar,
		closeDrawerByAnimation,
	} = props;

	const {
		requestDisconnect,
		requestReconnect,
		requestCancel,
		modals,
	} = useCompanyActions({ setSelectedSidebar, closeDrawerByAnimation });

	const plan = getPlanInfo(data?.subscription);
	const companyName = data?.company?.title;
	const qboConnected = !!data?.action;

	// --- Plan change modal (Upgrade / Downgrade) — DISABLED: single plan only ---
	// const { changePlan, isLoading: isPlanChanging } = usePlanChange();
	// const [planModal, setPlanModal] = useState<any>({ open: false });
	//
	// const openPlanModal = () => {
	// 	const isPlus = plan.isPlus;
	// 	setPlanModal({
	// 		open: true,
	// 		action: isPlus ? 'downgrade' : 'upgrade',
	// 		company: companyName,
	// 		fromPlan: plan.name,
	// 		toPlan: isPlus ? 'Basic' : 'Plus',
	// 		fromPrice: plan.price,
	// 		toPrice: isPlus ? 50 : 70,
	// 		renews: plan.renewalDate || '—',
	// 	});
	// };
	// const closePlanModal = () => setPlanModal((p: any) => ({ ...p, open: false }));
	// const confirmPlanChange = () => {
	// 	changePlan(data, planModal.action, closePlanModal);
	// };

	// Only QuickBooks Online is a real integration today, so the connected list
	// is built dynamically from the company's actual connection state.
	const connectedIntegrations = [
		{
			key: 'qbo',
			label: 'QuickBooks Online',
			badge: 'qb',
			color: '#2CA01C',
			meta: `Accounting · Required · Last sync ${data?.last_sync}`,
			connected: qboConnected,
		},
	];

	return (
		<div className={styles['manage']}>
			<div className={styles['manage__breadcrumb']}>
				<span className={styles['manage__breadcrumb-link']} onClick={onBack}>
					‹ Subscriptions
				</span>
				<span className={styles['manage__breadcrumb-sep']}>/</span>
				<span>{companyName}</span>
			</div>

			<div className={styles['manage__header']}>
				<div>
					<h2 className={styles['manage__title']}>{companyName}</h2>
					{plan.renewalDate && (
						<p className={styles['manage__renews']}>Renews {plan.renewalDate}</p>
					)}
				</div>
				<div className={styles['manage__plan']}>
					<span className={styles['manage__plan-label']}>Current plan</span>
					{/* Two-plan tier badge + upgrade/downgrade button — DISABLED (single plan only).
					<span
						className={`${styles['manage__plan-pill']} ${
							plan.isPlus
								? styles['manage__plan-pill--plus']
								: styles['manage__plan-pill--basic']
						}`}
					>
						{plan.name}
					</span> */}
					<span className={styles['manage__plan-price']}>
						${plan.price}/{plan.interval}
					</span>
					{/* <button
						className={`${styles['manage__plan-btn']} ${
							plan.isPlus
								? styles['manage__plan-btn--outline']
								: styles['manage__plan-btn--solid']
						}`}
						onClick={openPlanModal}
					>
						{plan.isPlus ? 'Downgrade to Basic' : 'Upgrade to Plus'}
					</button> */}
				</div>
			</div>

			<h3 className={styles['manage__section']}>Connected integrations</h3>
			<div className={styles['manage__list']}>
				{connectedIntegrations.map((it) => (
					<div className={styles['manage__card']} key={it.key}>
						<div className={styles['manage__card-left']}>
							<span
								className={styles['manage__badge']}
								style={{ background: it.color }}
							>
								{it.badge}
							</span>
							<div>
								<div className={styles['manage__card-title']}>
									{it.label}
									{it.connected ? (
										<span className={styles['manage__status--connected']}>
											Connected
										</span>
									) : (
										<span className={styles['manage__status--disconnected']}>
											Disconnected
										</span>
									)}
								</div>
								<p className={styles['manage__card-meta']}>{it.meta}</p>
							</div>
						</div>

						<div className={styles['manage__card-actions']}>
							{it.connected ? (
								<>
									<span
										className={styles['manage__action']}
										onClick={() => toastText('Sync started.', 'info')}
									>
										<SyncOutlined /> Sync
									</span>
									<span
										className={styles['manage__action--danger']}
										onClick={() => requestDisconnect(data)}
									>
										Disconnect
									</span>
								</>
							) : (
								<span
									className={styles['manage__action']}
									onClick={() => requestReconnect(data)}
								>
									Reconnect
								</span>
							)}
						</div>
					</div>
				))}
			</div>

			<div className={styles['manage__footer']}>
				<span
					className={styles['manage__cancel']}
					onClick={() => requestCancel(data)}
				>
					Cancel subscription
				</span>
			</div>

			{/* Plan change modal — DISABLED (single plan only).
			{planModal.open && (
				<PlanChangeModal
					open={planModal.open}
					action={planModal.action}
					company={planModal.company}
					fromPlan={planModal.fromPlan}
					toPlan={planModal.toPlan}
					fromPrice={planModal.fromPrice}
					toPrice={planModal.toPrice}
					renews={planModal.renews}
					onConfirm={confirmPlanChange}
					onCancel={closePlanModal}
					isLoading={isPlanChanging}
				/>
			)} */}

			{modals}
		</div>
	);
};

export default ManageCompany;
